/** Camera timing from DESIGN.md "Zoom". Mirrors --dur-camera / --ease-camera in tokens.css. */
export const CAMERA_DURATION = 0.6;
export const CAMERA_EASE = [0.2, 0.7, 0.2, 1] as const;
/** How far the overview layer flies in when we zoom into a node. */
export const ZOOM_IN_SCALE = 3.2;
/** Where the detail layer starts when it grows into place. */
export const DETAIL_START_SCALE = 0.3;
